import {PopoverAccessibilityController} from './popover-accessibility-controller';
import {PopoverAccessibilityControllerIf} from './interfaces/popover-accessibility-controller-if';
export let PopoverAccessibilityControllerFactory = {

  getPopoverAccessibilityControllerInstance(): PopoverAccessibilityControllerIf {
    return new PopoverAccessibilityController();
  }

};
